import { getEntityIconColor, getItemIcon } from "@/components/UnifiedRegistry/utils";
import { EntityType } from "@/queries";

interface EntityTagProps {
  metadata: Record<string, unknown>;
}
const EntityTag = ({ metadata }: EntityTagProps) => {
  if ("payload" in metadata && metadata.payload && typeof metadata.payload === "object") {
    if ("prompt_template_name" in metadata.payload) {
      const icon = getItemIcon(EntityType.PROMPT);
      const name = metadata.payload.prompt_template_name as string;
      const iconColor = getEntityIconColor(EntityType.PROMPT);

      return (
        <div className="inline-flex items-center gap-1 rounded text-xs">
          <span className={`${iconColor} text-[10px]`}>{icon}</span>
          <span className={`${iconColor} font-medium`}>{name}</span>
        </div>
      );
    } else if ("workflow_name" in metadata.payload) {
      const icon = getItemIcon(EntityType.WORKFLOW);
      const name = metadata.payload.workflow_name as string;
      const iconColor = getEntityIconColor(EntityType.WORKFLOW);

      return (
        <div className="inline-flex items-center gap-1 rounded text-xs">
          <span className={`${iconColor} text-[10px]`}>{icon}</span>
          <span className={`${iconColor} font-medium`}>{name}</span>
        </div>
      );
    } else if ("blueprint_name" in metadata.payload) {
      const icon = getItemIcon(EntityType.REPORT);
      const name = metadata.payload.blueprint_name as string;
      const iconColor = getEntityIconColor(EntityType.REPORT);

      return (
        <div className="inline-flex items-center gap-1 rounded text-xs">
          <span className={`${iconColor} text-[10px]`}>{icon}</span>
          <span className={`${iconColor} font-medium`}>{name}</span>
        </div>
      );
    }
  } else if ("entity_type" in metadata && "entity_name" in metadata) {
    const icon = getItemIcon(metadata.entity_type as EntityType);
    const name = metadata.entity_name as string;
    const iconColor = getEntityIconColor(metadata.entity_type as EntityType);

    return (
      <div className="inline-flex items-center gap-1 rounded text-xs">
        <span className={`${iconColor} text-[10px]`}>{icon}</span>
        <span className={`${iconColor} font-medium`}>{name}</span>
      </div>
    );
  }

  return null;
};

export default EntityTag;
